import { useNavigate } from 'react-router-dom';
import { Button } from '../ui';

export function EmptyDashboard() {
  const navigate = useNavigate();

  return (
    <div className="bg-card border border-border rounded-card p-12 text-center">
      <p className="font-display text-xl text-heading mb-2 [font-variation-settings:'opsz'_96,'SOFT'_60]">
        Start your first book
      </p>
      <p className="text-sm text-muted-foreground leading-relaxed mb-8 max-w-[360px] mx-auto">
        Answer five short questions and we will generate a creative brief for your novel.
      </p>
      <Button onClick={() => navigate('/brief/new')}>
        Begin
        <span aria-hidden="true">&rarr;</span>
      </Button>
    </div>
  );
}
